import { render, staticRenderFns } from "./KoioteImageSwitchHoverProperties.vue?vue&type=template&id=6c4b62b9&lang=es"
import script from "./KoioteImageSwitchHoverProperties.vue?vue&type=script&lang=js"
export * from "./KoioteImageSwitchHoverProperties.vue?vue&type=script&lang=js"
import style0 from "./KoioteImageSwitchHoverProperties.vue?vue&type=style&index=0&id=6c4b62b9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports